<div
    class="banner-container"
    *ngIf="bannerItems.length"
    [ngClass]="{ 'side-nav-open': isSideNavOpen, 'is-mobile': isMobile, 'has-secondary-nav': hasSecondaryNav }"
>
    <div class="banner">
        <!-- this can be updated when there's a design or requirement for more than one item, currently just showing first item -->
        <div class="banner-info-container">
            <img class="alert" src="assets/images/yellow-alert.svg" alt="warning icon" />
            <p>{{ bannerItems[0].message }}</p>
        </div>
        <div *ngIf="bannerItems[0].buttonText && bannerItems[0].method" class="banner-button-container">
            <button mat-raised-button (click)="bannerItems[0].method()">{{ bannerItems[0].buttonText }}</button>
        </div>
    </div>
</div>
